import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { InputMask, Modal } from "src/components";
import { Save as SaveIcon, Cancel as CancelIcon } from "@material-ui/icons";
import { atualizar, cadastrar } from "src/store/actions/complementos";

function ModalComplementos({ open, close, type, complemento }) {
  const [formComplemento, setFormComplemento] = useState(complemento);

  useEffect(() => {
    if (!complemento) {
      setFormComplemento({ titulo: "", valor_atual: "", status: "A" });
    } else {
      setFormComplemento(complemento);
    }
  }, [complemento]);

  const handleChange = (event) => {
    setFormComplemento({
      ...formComplemento,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async () => {
    if (type === "insert") {
      await cadastrar(formComplemento);
    } else {
      await atualizar(formComplemento);
    }

    setFormComplemento({ titulo: "", valor_atual: "", status: "A" });
    close();
  };

  return (
    <Modal open={open}>
      <Box display="flex" flexDirection="column" gap="8px">
        <Typography>
          {type === "update"
            ? "Atualizar complemento"
            : "Cadastrar complemento"}
        </Typography>
        <ValidatorForm onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <TextValidator
                fullWidth
                label="Título"
                name="titulo"
                onChange={handleChange}
                value={formComplemento.titulo}
                validators={["required"]}
                errorMessages={["Campo obrigatório"]}
                margin="dense"
              />
            </Grid>
            <Grid item sm={6}>
              <InputMask
                type="cash"
                name="valor_atual"
                label="Valor Atual"
                onChange={(e) =>
                  setFormComplemento({
                    ...formComplemento,
                    valor_atual: e.target.values.floatValue,
                  })
                }
                value={formComplemento.valor_atual}
              />
            </Grid>
            <Grid item sm={6}>
              <TextValidator
                fullWidth
                select
                label="Situação"
                name="situacao"
                onChange={handleChange}
                value={formComplemento.situacao}
                SelectProps={{
                  native: true,
                }}
                InputLabelProps={{ shrink: true }}
                margin="dense"
              >
                <option value="A"> Ativo </option>
                <option value="I"> Inativo </option>
              </TextValidator>
            </Grid>
          </Grid>

          <Box display="flex" justifyContent="flex-end">
            <Button type="submit" color="primary" size="small">
              {<SaveIcon />}&nbsp;Gravar
            </Button>
            <Button color="secondary" size="small" onClick={close}>
              {<CancelIcon />}&nbsp;Cancelar
            </Button>
          </Box>
        </ValidatorForm>
      </Box>
    </Modal>
  );
}

export default ModalComplementos;
